import React, { useEffect, useState } from 'react'
import { API_URL } from './constant'
import TestimonialComponent from '../Components/TestimonialComponent/TestimonialComponent';
import candidate from "../Assets/candidate.svg";
import completed from "../Assets/completed.svg";
import interviewers from "../Assets/interviewers.svg";
import registered from "../Assets/registered.svg";

const RegisterCountComponent = () => {

    const [registerCount, setRegisterCount] = useState([]);

    useEffect(() => {
        fetch(`${API_URL}api/registerCount`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then((response) => response.json())
            .then((response) => setRegisterCount(response))
    }, [])
    return (
        <>
            <div className="d-flex justify-content-start flex-column h-100 px-4 pt-2">
            <p className="text-white fw-semibold text-start fs-5  "
               style={{fontFamily: "inherit"}}>
            •Structured L1 and L2 interviews for faster hiring -
                <a
                href="https://ralainfotech.com/services/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#FEDA14", fontFamily: "inherit", textDecoration: "none" }}
                >
                Explore our services
                </a>
            </p>
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 text-start pt-1 tilt">
                        <div className="icon-wrap">
                            <img src={candidate} alt="candidate-icon" />
                        </div>
                        <div className="fw-bold display-5 text-white text-uppercase mt-4">
                            {registerCount?.length > 0 ? `${registerCount[0]?.candidate_registered_count}+` : "2053+"}
                        </div>
                        <div className="fw-bold text-uppercase text_highlite mt-3">
                            CANDIDATES REGISTERED
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 text-start pt-1 tilt">
                        <div className="icon-wrap">
                            <img src={completed} alt="completed-icon" />
                        </div>
                        <div className="fw-bold display-5 text-white text-uppercase mt-4">
                            {registerCount?.length > 0 ? `${registerCount[0]?.completed_interview_count}+` : "45,694+"}
                        </div>
                        <div className="fw-bold text-uppercase text_highlite mt-3">
                            COMPLETED INTERVIEWS
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 text-start pt-1 tilt">
                        <div className="icon-wrap">
                            <img src={registered} alt="registered-icon" />
                        </div>
                        <div className="fw-bold display-5 text-white text-uppercase mt-4">
                            {registerCount?.length > 0 ? `${registerCount[0]?.company_registered_count}+` : "18+"}
                        </div>
                        <div className="fw-bold text-uppercase text_highlite mt-3">
                            COMPANIES REGISTERED
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 text-start pt-1 tilt">
                        <div className="icon-wrap">
                            <img src={interviewers} alt="interviewers-icon" />
                        </div>
                        <div className="fw-bold display-5 text-white text-uppercase mt-4">
                            {registerCount?.length > 0 ? `${registerCount[0]?.interviews_count}+` : "2053+"}
                        </div>
                        <div className="fw-bold text-uppercase text_highlite mt-3">
                            INTERVIEWERS
                        </div>
                    </div>
                </div>   
                <TestimonialComponent
                    autoRotate={true}
                    rotationInterval={5000}
                    showBullets={true}
                    className="testimonials-section"
                />
            </div>
        </>
    )
}

export default RegisterCountComponent